import JawsSegmentation from '../three/JawsSegmentation.ts';
import JawSegmentation from '../three/JawSegmentation.ts';
import { JawsScanResponse } from '@/schema/jawsScan';
import { BaseThreeScene } from '@modules/three/common/BaseThreeScene';
import { segmentationStore } from '@segmentation/store/segmentationStore.ts';

export default class SegmentationService {
  constructor() {}

  public async createJaws(data: JawsScanResponse) {
    const geoms = await BaseThreeScene.loadGeometries([data.upperJaw.model3dUrl, data.lowerJaw.model3dUrl]);
    const upperJaw = new JawSegmentation(geoms[0], data.upperJaw.teethEdges, true);
    const lowerJaw = new JawSegmentation(geoms[1], data.lowerJaw.teethEdges);
    const jaws = new JawsSegmentation(lowerJaw, upperJaw);
    segmentationStore.getState().setJaws(jaws);
  }
}
